import { Component, Type } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NoDataComponent } from '../../Component/NoData/no-data/no-data.component';
import { CommonService } from '../../Model/Common/common.service';
import { RateContractService } from '../../Model/RateContract/rate-contract.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SalaryBillingRatecontractFormulaComponent } from '../salary-billing-ratecontract-formula/salary-billing-ratecontract-formula.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-salary-billing-ratecontract',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, LoaderComponent, NgbTooltipModule, NoDataComponent, NgbDatepickerModule],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './salary-billing-ratecontract.component.html',
  styleUrl: './salary-billing-ratecontract.component.scss'
})
export class SalaryBillingRatecontractComponent {
  isDisabled: boolean = false;
  user = [] as any;
  Clients = [] as any;
  Groups = [] as any;
  Designations = [] as any;
  Dutys = [] as any;
  SalaryHeads = [] as any;
  IsReset = false;

  SalaryHeadDetails = [] as any;
  SalaryHeadDetailsOTs = {
    OTType: "",
    OTFormula: "",
    OTRate: 0,
    OTCalculationOn: "",
    OTCalculationValue: 0,
    SpecialOTType: "",
    SpecialOTFormula: "",
    SpecialOTRate: 0,
    SpecialOTCalculationOn: "",
    SpecialOTCalculationValue: 0,
    WOType: "",
    WOFormula: "",
    WOValue: 0,
    WOOption: "",
    TrackingNo: "",
    ID: 0,
    DocumentPath: "",
    SalaryTotal: 0,
    NetTotal: 0,
    CTCTotal: 0,
    WeeklyOffAmount: 0,
    LeaveType: "",
    LeaveFormula: "",
    LeaveValue: 0,
    HolidayType: "",
    HolidayFormula: "",
    HolidayValue: 0
  } as any;
  SalaryHeadDetailsBillingOTs = {
    RoundOff: 0,
    TrackingNo: "",
    ID: 0,
    DocumentPath: "",
    OTBRate: 0,
    NationalHolidayRate: 0,
    BOTType: "",
    BOTCalculationOn: "",
    BOTCalculationValue: 0,
    BHolidayType: "",
    BHolidayCalculationOn: "",
    BHolidayCalculationValue: 0
  } as any;
  AdditionalDetails = [] as any;
  ServiceDetails = [] as any;
  Totals = {
    total: 0 as any,
    roundoff: 0 as any,
    billingtotal: 0 as any,
    deduction: 0 as any,
    grosstotal: 0 as any,
    nettotal: 0 as any,
    ctctotal: 0 as any,
    benchmark: 0 as any,
  }
  Fromulas = [] as any;

  Computations = [{ Label: 'Fixed Value', Value: 'Fixed Value', id: [1, 2, 3, 4, 5, 6, 8, 9] },
  { Label: 'Fixed-Parameter', Value: 'Fixed-Parameter', id: [1] },
  { Label: 'Formula', Value: 'Formula', id: [1, 2, 3, 4, 8] },
  { Label: 'Pro-Rated', Value: 'Pro-Rated', id: [1] },
  { Label: 'Slab-Rate', Value: 'Slab-Rate', id: [1] },
  { Label: 'Per Employee', Value: 'Per Employee', id: [3] },
  { Label: 'Percentage', Value: 'Percentage', id: [3, 8] },
  { Label: 'OnAmount', Value: 'OnAmount', id: [4, 9] },
  { Label: 'Total Working Days', Value: 'Total Working Days', id: [5, 6] },
  { Label: 'Total Month Days', Value: 'Total Month Days', id: [5, 6] },
  { Label: 'Month Days -', Value: 'Month Days -', id: [5] },
  { Label: 'Weekly Off', Value: 'Weekly Off', id: [7] },
  { Label: 'Divide by 7', Value: 'Divide by 7', id: [7], }];

  MonthYears = [{ Label: 'Monthly', Value: 'Monthly' }, { Label: 'Yearly', Value: 'Yearly' }];
  ExcludefromPF = [] as any;
  ExcludefromESI = [] as any;
  Filter = {
    MonthYear: null as any,
    //BranchID: null,
    ClientGroupID: null,
    GroupID: null,
    DesignationID: null,
    DutyID: null,
    SalaryHeadMasterID: null,
  }

  constructor(
    protected common: CommonService,
    private rateContract: RateContractService,
    private session: SessionService,
    private modalService: NgbModal,
    private toast: ToastService,
    private utility: UtilityService,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    //this.common.CompanyParameter();
    this.user = this.session.GetUserDetails();
    //this.common.getPageRights();
    this.common.PageRight.IsAdd = true;
  }

  ngOnInit() {
    this.SelectDate('RegistrationDate');
    this.DocFillComboLoad('ClientGroupID');
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.DocFillComboLoad('SalaryHeadID');
      this.ContractRateSalaryBillingLoad(1);

      this.GetSalaryHeadCodeForRateContract('Exclude from PF');
      this.GetSalaryHeadCodeForRateContract('Exclude from ESI');
    }
    else {
      form.submitted = true;
    }
  }

  onNavigate(event: any) {
    this.Filter.MonthYear = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  DocFillComboLoad(SelectType: string) {
    if (SelectType == 'ClientGroupID') {
      this.Clients = [];
      this.Groups = [];
      this.Designations = [];
      this.Dutys = [];

      this.Filter.ClientGroupID = null;
      this.Filter.GroupID = null;
      this.Filter.DesignationID = null;
      this.Filter.DutyID = null;
    } else if (SelectType == 'GroupFromClient') {
      this.Groups = [];
      this.Designations = [];
      this.Dutys = [];

      this.Filter.GroupID = null;
      this.Filter.DesignationID = null;
      this.Filter.DutyID = null;
    } else if (SelectType == 'SiteDesignationID') {
      this.Designations = [];
      this.Dutys = [];

      this.Filter.DesignationID = null;
      this.Filter.DutyID = null;
    } else if (SelectType == 'SiteDutyID') {
      this.Dutys = [];

      this.Filter.DutyID = null;
    } else if (SelectType == 'SalaryHeadID') {
      this.Filter.SalaryHeadMasterID = null;
      this.SalaryHeads = [];
    }

    this.isDisabled = true;
    this.rateContract.DocFillComboLoad({ SelectType: SelectType, ID1: this.Filter.ClientGroupID, Code1: '', ID2: this.Filter.GroupID, Code2: '', ID3: this.Filter.DesignationID, Code3: '', EmpType: this.user.EmpType }).subscribe({
      next: (response) => {
        if (SelectType == 'ClientGroupID') {
          this.Clients = response.Table;
        } else if (SelectType == 'GroupFromClient') {
          this.Groups = response.Table;
        } else if (SelectType == 'SiteDesignationID') {
          this.Designations = response.Table;
        } else if (SelectType == 'SiteDutyID') {
          this.Dutys = response.Table;
        } else if (SelectType == 'SalaryHeadID') {
          this.SalaryHeads = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ContractRateSalaryBillingLoad(SelectType: number) {
    this.isDisabled = true;
    this.rateContract.ContractRateSalaryBillingLoad({ SelectType: SelectType, MonthYear: this.dateFormat.format(this.Filter.MonthYear), BranchID: 0, ClientGroupID: this.Filter.ClientGroupID, GroupID: this.Filter.GroupID, DesignationID: this.Filter.DesignationID, DutyID: this.Filter.DutyID, SalaryHeadMasterID: 0 }).subscribe({
      next: (response) => {
        if (response && response.Table) {
          if (SelectType == 1) {
            this.SalaryHeadDetails = response.Table;
            this.SalaryHeadDetails.forEach((element: any) => {
              this.CheckIsDisabled(element, SelectType);
            });

            this.Fromulas = [
              ...this.Fromulas,
              ...this.SalaryHeadDetails.map((e: any) => ({ SalaryHeadMasterID: e.SalaryHeadMasterID, SalaryHeadCode: e.SalaryHeadCode, SalaryHeadName: e.SalaryHeadName, EarningDeduction: e.EarningDeduction, HeadType: e.HeadType, SelectType: 1 }))];
            if (response.Table1) {
              this.SalaryHeadDetailsOTs = response.Table1[0];

              this.CheckIsDisabled(this.SalaryHeadDetailsOTs, 4, 'OTType');
              this.CheckIsDisabled(this.SalaryHeadDetailsOTs, 4, 'SpecialOTType');
              this.CheckIsDisabled(this.SalaryHeadDetailsOTs, 4, 'WOType');
              this.CheckIsDisabled(this.SalaryHeadDetailsOTs, 4, 'LeaveType');
              this.CheckIsDisabled(this.SalaryHeadDetailsOTs, 4, 'HolidayType');
            }
            if (response.Table2) {
              this.SalaryHeadDetailsBillingOTs = response.Table2[0];
              this.CheckIsDisabled(this.SalaryHeadDetailsBillingOTs, 4, 'BOTType');
              this.CheckIsDisabled(this.SalaryHeadDetailsBillingOTs, 4, 'BHolidayType');
            }

          } else if (SelectType == 2) {
            this.AdditionalDetails = response.Table;
            this.AdditionalDetails.forEach((element: any) => {
              this.CheckIsDisabled(element, SelectType);
            });
            this.Fromulas = [
              ...this.Fromulas,
              ...this.AdditionalDetails.map((e: any) => ({ SalaryHeadMasterID: e.RCChargesMasterID, SalaryHeadCode: e.RCChargesCode, SalaryHeadName: e.RCChargesName, SelectType: 2 }))
            ];
          } else if (SelectType == 3) {
            this.ServiceDetails = response.Table;
            this.ServiceDetails.forEach((element: any) => {
              this.CheckIsDisabled(element, SelectType);
            });
            this.Fromulas = [
              ...this.Fromulas,
              ...this.ServiceDetails.map((e: any) => ({ SalaryHeadMasterID: e.Column1, SalaryHeadCode: e.ServiceChargeCode, SalaryHeadName: e.ServiceChargeName, SelectType: 3 }))
            ];
          }
        } else {
          if (SelectType == 1) {
            this.SalaryHeadDetails = [];
          } else if (SelectType == 2) {
            this.AdditionalDetails = [];
          }

        }
        this.CalcTotal();
        this.IsReset = true;
        this.isDisabled = false;
      },
      complete: () => {
        if (SelectType == 1) {
          this.ContractRateSalaryBillingLoad(2);
        } else if (SelectType == 2) {
          this.ContractRateSalaryBillingLoad(3);
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadDefaultParamDeduction(SelectType: number, index: number, Type: string) {
    this.isDisabled = true;
    this.rateContract.LoadDefaultParamDeduction({ SelectType: SelectType, SalaryHeadID: this.SalaryHeadDetails[index].SalaryHeadMasterID, BranchID: 0 }).subscribe({
      next: (response) => {
        if (response && response.data) {
          if (response.data.LoadDefaultParamDeduction.length > 0) {
            if ((Type == 'B' && this.common.ToLowerCase(this.SalaryHeadDetails[index].BComputation) == this.common.ToLowerCase(response.data.LoadDefaultParamDeduction[0].Computation)) ||
              (Type == 'S' && this.common.ToLowerCase(this.SalaryHeadDetails[index].SComputation) == this.common.ToLowerCase(response.data.LoadDefaultParamDeduction[0].Computation))) {
              if (Type == 'B') {
                this.SalaryHeadDetails[index].BPercentage = response.data.LoadDefaultParamDeduction[0].Column1;
                this.SalaryHeadDetails[index].BAmount = 0;
                this.SalaryHeadDetails[index].BMaxAmount = response.data.LoadDefaultParamDeduction[0].Column2;
                this.SalaryHeadDetails[index].BFormula = response.data.LoadDefaultParamDeduction[0].Formula1;
              }
              if (Type == 'B' || Type == 'S') {
                this.SalaryHeadDetails[index].SPercentage = response.data.LoadDefaultParamDeduction[0].Column1;
                this.SalaryHeadDetails[index].SAmount = 0;
                this.SalaryHeadDetails[index].SMaxAmount = response.data.LoadDefaultParamDeduction[0].Column2;
                this.SalaryHeadDetails[index].SFormula = response.data.LoadDefaultParamDeduction[0].Formula1;
              }

              if (this.common.ToLowerCase(response.data.LoadDefaultParamDeduction[0].Formula1).includes('gross')) {
                this.CalcGross(SelectType, index, Type);
              } else {
                this.CalculateOnAmount(this.SalaryHeadDetails[index], Type, SelectType);
              }
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = "Parameter Not Defined";
              modalRef.result.then((result: any) => { });
            }
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Message;
            modalRef.result.then((result: any) => { });
          }
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Parameter Not Defined";
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SalaryHeadMasterSELECT(SelectType: number) {
    this.isDisabled = true;
    this.rateContract.SalaryHeadMasterSELECT({ SelectType: SelectType, Code: this.Filter.SalaryHeadMasterID }).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.SalaryHeadDetails.push({
            SalaryHeadMasterID: response[0].SalaryHeadMasterId,
            SalaryHeadCode: response[0].SalaryHeadCode,
            SalaryHeadName: response[0].SalaryHeadName,
            BAmount: 0,
            BAmountIsDisabled: false,
            BComputation: response[0].Computation,
            BFormula: "",
            BMaxAmount: "0.00",
            BMaxAmountIsDisabled: false,
            BMonthlyYearly: "Monthly",
            BOnAmount: 0,
            BPercentage: 0,
            BPercentageIsDisabled: false,
            Column1: response[0].PaySlip,
            EarningDeduction: response[0].EarningDeduction,
            Flag: "N",
            HeadType: response[0].TypeSB,
            SAmount: 0,
            SAmountIsDisabled: false,
            SComputation: response[0].Computation,
            SFormula: "",
            SMaxAmount: 0,
            SMaxAmountIsDisabled: false,
            SMonthlyYearly: "Monthly",
            SOnAmount: 0,
            SPercentage: 0,
            SPercentageIsDisabled: false,
          });
          this.toast.show({ message: 'Head added.', type: toastTypeEnum.success });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Head not found";
          modalRef.result.then((result: any) => { });
        }

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetSalaryHeadCodeForRateContract(SelectType: string) {
    this.isDisabled = true;
    this.rateContract.GetSalaryHeadCodeForRateContract({ SelectType: SelectType }).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          if (response[0].Column1) {
            if (SelectType == 'Exclude from PF') {
              this.ExcludefromPF = this.common.ToLowerCase(response[0].Column1).split(',');
            } else if (SelectType == 'Exclude from ESI') {
              this.ExcludefromESI = this.common.ToLowerCase(response[0].Column1).split(',');
            }
          } else {
            if (SelectType == 'Exclude from PF') {
              this.ExcludefromPF = [];
            } else if (SelectType == 'Exclude from ESI') {
              this.ExcludefromESI = [];
            }
          }
        } else {
          if (SelectType == 'Exclude from PF') {
            this.ExcludefromPF = [];
          } else if (SelectType == 'Exclude from ESI') {
            this.ExcludefromESI = [];
          }
        }

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetComputations(id: number) {
    return this.Computations.filter(e => e.id.includes(id));
  }

  ComputationChange(index: number, SelectType: number, Type: string, IsComputation = false) {
    if (((SelectType == 1 && this.common.ToLowerCase(this.SalaryHeadDetails[index].HeadType) != 's') || SelectType == 2 || SelectType == 3) || !IsComputation) {
      if (SelectType == 1 && Type == 'B') {
        this.SalaryHeadDetails[index].SComputation = this.SalaryHeadDetails[index].BComputation;
        this.SalaryHeadDetails[index].SPercentage = this.SalaryHeadDetails[index].BPercentage;
        this.SalaryHeadDetails[index].SAmount = this.SalaryHeadDetails[index].BAmount;
        this.SalaryHeadDetails[index].SMonthlyYearly = this.SalaryHeadDetails[index].BMonthlyYearly;
        this.SalaryHeadDetails[index].SMaxAmount = this.SalaryHeadDetails[index].BMaxAmount;
      }


      if (SelectType == 1 && (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc' ||
        this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' ||
        this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie')) {
        if (Type == 'B') {
          if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
            this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].BComputation = this.SalaryHeadDetails[index].BComputation;
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
            this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].BComputation = this.SalaryHeadDetails[index].BComputation;
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
            this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].BComputation = this.SalaryHeadDetails[index].BComputation;
          }
        }

        if (Type == 'B' || Type == 'S') {
          if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
            this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].SComputation = this.SalaryHeadDetails[index].SComputation;
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
            this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].SComputation = this.SalaryHeadDetails[index].SComputation;
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
            this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].SComputation = this.SalaryHeadDetails[index].SComputation;
          }
        }

        if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
          this.CheckIsDisabled(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')], SelectType);
        } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
          this.CheckIsDisabled(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')], SelectType);
        } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
          this.CheckIsDisabled(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')], SelectType);
        }

      }

      if (SelectType == 1) {
        this.CheckIsDisabled(this.SalaryHeadDetails[index], SelectType);
      } else if (SelectType == 2) {
        this.CheckIsDisabled(this.AdditionalDetails[index], SelectType);
      } else if (SelectType == 3) {
        this.CheckIsDisabled(this.ServiceDetails[index], SelectType);
      }

      if (SelectType == 1 && ((Type == 'B' && this.common.ToLowerCase(this.SalaryHeadDetails[index].BComputation) == 'formula') ||
        (Type == 'S' && this.common.ToLowerCase(this.SalaryHeadDetails[index].SComputation) == 'formula'))) {
        this.FormulaPopup(index, SelectType, Type);
      } else if (SelectType == 2 && this.common.ToLowerCase(this.AdditionalDetails[index].Computation) == 'formula') {
        this.FormulaPopup(index, SelectType, Type);
      } else if (SelectType == 3 && this.common.ToLowerCase(this.ServiceDetails[index].Computation) == 'formula') {
        this.FormulaPopup(index, SelectType, Type);
      } else if (SelectType == 4 && this.common.ToLowerCase(this.SalaryHeadDetailsOTs[Type]) == 'formula') {
        this.FormulaPopup(index, SelectType, Type);
      } else if (SelectType == 1 && ((Type == 'B' && this.common.ToLowerCase(this.SalaryHeadDetails[index].BComputation) != 'formula') ||
        (Type == 'S' && this.common.ToLowerCase(this.SalaryHeadDetails[index].SComputation) != 'formula'))) {
        if (Type == 'B') {
          if (SelectType == 1 && (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc' ||
            this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' ||
            this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie')) {
            if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].BPercentage = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].BAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].BMaxAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].BFormula = "";
            } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].BPercentage = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].BAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].BMaxAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].BFormula = "";
            } if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].BPercentage = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].BAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].BMaxAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].BFormula = "";
            }
          }

          this.SalaryHeadDetails[index].BPercentage = 0;
          this.SalaryHeadDetails[index].BAmount = 0;
          this.SalaryHeadDetails[index].BMaxAmount = 0;
          this.SalaryHeadDetails[index].BFormula = "";
        }

        if (Type == 'B' || Type == 'S') {
          if (SelectType == 1 && (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc' ||
            this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' ||
            this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie')) {
            if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].SPercentage = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].SAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].SMaxAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].SFormula = "";
            } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].SPercentage = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].SAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].SMaxAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].SFormula = "";
            } if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].SPercentage = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].SAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].SMaxAmount = 0;
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].SFormula = "";
            }
          }

          this.SalaryHeadDetails[index].SPercentage = 0;
          this.SalaryHeadDetails[index].SAmount = 0;
          this.SalaryHeadDetails[index].SMaxAmount = 0;
          this.SalaryHeadDetails[index].SFormula = "";
        }
      } else if (SelectType == 2 && this.common.ToLowerCase(this.AdditionalDetails[index].Computation) != 'formula') {
        this.AdditionalDetails[index].Column2 = 0;
        this.AdditionalDetails[index].Column3 = "";
        this.AdditionalDetails[index].A = 0;
      } else if (SelectType == 3 && this.common.ToLowerCase(this.ServiceDetails[index].Computation) != 'formula') {
        this.AdditionalDetails[index].Column2 = 0;
        this.AdditionalDetails[index].Column3 = "";
        this.AdditionalDetails[index].A = 0;
      }

      if (SelectType == 1 && ((Type == 'B' && (this.common.ToLowerCase(this.SalaryHeadDetails[index].BComputation) == 'fixed-parameter' || this.common.ToLowerCase(this.SalaryHeadDetails[index].BComputation) == 'slab-rate')) ||
        (Type == 'S' && (this.common.ToLowerCase(this.SalaryHeadDetails[index].SComputation) == 'fixed-parameter' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SComputation) == 'slab-rate')))) {
        this.LoadDefaultParamDeduction(1, index, Type);

        if (SelectType == 1 && (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc' ||
          this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' ||
          this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie')) {
          if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
            this.CheckIsDisabled(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')], SelectType);
            this.LoadDefaultParamDeduction(1, this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf'), Type);
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
            this.CheckIsDisabled(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')], SelectType);
            this.LoadDefaultParamDeduction(1, this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf'), Type);
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
            this.CheckIsDisabled(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')], SelectType);
            this.LoadDefaultParamDeduction(1, this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic'), Type);
          }
        }
      }

      if (SelectType == 1 && this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
        this.ComputationChange(this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf'), SelectType, Type, IsComputation);
      } else if (SelectType == 1 && this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
        this.ComputationChange(this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf'), SelectType, Type, IsComputation);
      } else if (SelectType == 1 && this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
        this.ComputationChange(this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic'), SelectType, Type, IsComputation);
      }
    } else if (SelectType == 4 || SelectType == 5) {
      if (SelectType == 4 && Type == 'OTType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTType) == 'fixed value') {
          this.SalaryHeadDetailsOTs.OTFormula = "";
          this.SalaryHeadDetailsOTs.OTCalculationOn = "";
          this.SalaryHeadDetailsOTs.OTCalculationValue = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTType) == 'formula') {
          this.SalaryHeadDetailsOTs.OTRate = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTType) == 'onamount') {
          this.SalaryHeadDetailsOTs.OTFormula = "";
        }
      } else if (SelectType == 4 && Type == 'SpecialOTType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTType) == 'fixed value') {
          this.SalaryHeadDetailsOTs.SpecialOTFormula = "";
          this.SalaryHeadDetailsOTs.SpecialOTCalculationOn = "";
          this.SalaryHeadDetailsOTs.SpecialOTCalculationValue = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTType) == 'formula') {
          this.SalaryHeadDetailsOTs.SpecialOTRate = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTType) == 'onamount') {
          this.SalaryHeadDetailsOTs.SpecialOTFormula = "";
        }
      } else if (SelectType == 4 && Type == 'LeaveType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'fixed value') {
          this.SalaryHeadDetailsOTs.LeaveFormula = "";
          this.SalaryHeadDetailsOTs.LeaveCalculationOn = "";
          this.SalaryHeadDetailsOTs.LeaveCalculationValue = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'formula' || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'percentage') {
          this.SalaryHeadDetailsOTs.LeaveValue = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'onamount') {
          this.SalaryHeadDetailsOTs.LeaveFormula = "";
        }
      } else if (SelectType == 4 && Type == 'HolidayType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'fixed value') {
          this.SalaryHeadDetailsOTs.HolidayFormula = "";
          this.SalaryHeadDetailsOTs.HolidayCalculationOn = "";
          this.SalaryHeadDetailsOTs.HolidayCalculationValue = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'formula' || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'percentage') {
          this.SalaryHeadDetailsOTs.HolidayValue = 0;
        } else if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'onamount') {
          this.SalaryHeadDetailsOTs.HolidayFormula = "";
        }
      } else if (SelectType == 4 && Type == 'BOTType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsBillingOTs.BOTType) == 'fixed value') {
          this.SalaryHeadDetailsBillingOTs.BOTCalculationOn = "";
          this.SalaryHeadDetailsBillingOTs.BOTCalculationValue = 0;
        }
      } else if (SelectType == 4 && Type == 'BHolidayType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsBillingOTs.BHolidayType) == 'fixed value') {
          this.SalaryHeadDetailsBillingOTs.BHolidayCalculationOn = "";
          this.SalaryHeadDetailsBillingOTs.BHolidayCalculationValue = 0;
        }
      }

      if (SelectType == 4 && Type == 'OTType' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTType) == 'formula'
        && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTCalculationOn) != 'fixed value' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTCalculationOn) != 'month days -')) {
        this.SalaryHeadDetailsOTs.OTCalculationOn = "";
        this.SalaryHeadDetailsOTs.OTCalculationValue = 0;
      } else if (SelectType == 4 && Type == 'SpecialOTType' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTType) == 'formula'
        && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTCalculationOn) != 'fixed value' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTCalculationOn) != 'month days -')) {
        this.SalaryHeadDetailsOTs.SpecialOTCalculationOn = "";
        this.SalaryHeadDetailsOTs.SpecialOTCalculationValue = 0;
      } else if (SelectType == 4 && Type == 'LeaveType' && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'formula' || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'percentage')
        && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveCalculationOn) != 'fixed value' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveCalculationOn) != 'month days -')) {
        this.SalaryHeadDetailsOTs.LeaveCalculationOn = "";
        this.SalaryHeadDetailsOTs.LeaveCalculationValue = 0;
      } else if (SelectType == 4 && Type == 'HolidayType' && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'formula' || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'percentage')
        && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayCalculationOn) != 'fixed value' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayCalculationOn) != 'month days -')) {
        this.SalaryHeadDetailsOTs.HolidayCalculationOn = "";
        this.SalaryHeadDetailsOTs.HolidayCalculationValue = 0;
      }

      
      if (SelectType == 5 && Type == 'OTType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTCalculationOn) == 'total working days'
          || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTCalculationOn) == 'total month days') {
          this.SalaryHeadDetailsOTs.OTCalculationValue = 0;
        }
      } else if (SelectType == 5 && Type == 'SpecialOTType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTCalculationOn) == 'total working days'
          || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTCalculationOn) == 'total month days') {
          this.SalaryHeadDetailsOTs.SpecialOTCalculationValue = 0;
        }
      } else if (SelectType == 5 && Type == 'LeaveType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveCalculationOn) == 'total working days'
          || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveCalculationOn) == 'total month days') {
          this.SalaryHeadDetailsOTs.LeaveCalculationValue = 0;
        }
      } else if (SelectType == 5 && Type == 'HolidayType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayCalculationOn) == 'total working days'
          || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayCalculationOn) == 'total month days') {
          this.SalaryHeadDetailsOTs.HolidayCalculationValue = 0;
        }
      } else if (SelectType == 5 && Type == 'BOTType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsBillingOTs.BOTCalculationOn) == 'total working days'
          || this.common.ToLowerCase(this.SalaryHeadDetailsBillingOTs.BOTCalculationOn) == 'total month days') {
          this.SalaryHeadDetailsBillingOTs.BOTCalculationValue = 0;
        }
      } else if (SelectType == 5 && Type == 'BHolidayType') {
        if (this.common.ToLowerCase(this.SalaryHeadDetailsBillingOTs.BHolidayCalculationOn) == 'total working days'
          || this.common.ToLowerCase(this.SalaryHeadDetailsBillingOTs.BHolidayCalculationOn) == 'total month days') {
          this.SalaryHeadDetailsBillingOTs.BHolidayCalculationValue = 0;
        }
      }

      if (Type == 'BOTType' || Type == 'BHolidayType') {
        this.CheckIsDisabled(this.SalaryHeadDetailsBillingOTs, SelectType, Type);
      } else {
        this.CheckIsDisabled(this.SalaryHeadDetailsOTs, SelectType, Type);
      }

      if (IsComputation) {
        if (SelectType == 4 && Type == 'OTType' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.OTType) == 'formula') {
          this.FormulaPopup(0, SelectType, Type);
        } else if (SelectType == 4 && Type == 'SpecialOTType' && this.common.ToLowerCase(this.SalaryHeadDetailsOTs.SpecialOTType) == 'formula') {
          this.FormulaPopup(0, SelectType, Type);
        } else if (SelectType == 4 && Type == 'LeaveType' && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'formula' || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.LeaveType) == 'percentage')) {
          this.FormulaPopup(0, SelectType, Type);
        } else if (SelectType == 4 && Type == 'HolidayType' && (this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'formula' || this.common.ToLowerCase(this.SalaryHeadDetailsOTs.HolidayType) == 'percentage')) {
          this.FormulaPopup(0, SelectType, Type);
        }
      }
    }
  }

  FormulaPopup(index: number, SelectType: number, Type: string) {
    const modalRef = this.modalService.open(SalaryBillingRatecontractFormulaComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.SelectType = SelectType;
    if (SelectType == 1) {
      modalRef.componentInstance.Formulas = structuredClone(this.Fromulas.filter((e: any) => this.common.ToLowerCase(e.EarningDeduction) == 'earning' && e.SelectType == 1));
      //modalRef.componentInstance.Formulas = structuredClone(this.Fromulas.filter((e: any) => e.EarningDeduction == this.SalaryHeadDetails[index].EarningDeduction && e.SalaryHeadCode != this.SalaryHeadDetails[index].SalaryHeadCode));
      if (Type == 'B') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetails[index].BFormula;
        modalRef.componentInstance.SalaryHeadCode = this.SalaryHeadDetails[index].SalaryHeadCode;
        modalRef.componentInstance.SalaryHeadNamee = this.SalaryHeadDetails[index].SalaryHeadName;
        modalRef.componentInstance.Percentage = this.SalaryHeadDetails[index].BPercentage;
      } else if (Type == 'S') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetails[index].SFormula;
        modalRef.componentInstance.SalaryHeadCode = this.SalaryHeadDetails[index].SalaryHeadCode;
        modalRef.componentInstance.SalaryHeadNamee = this.SalaryHeadDetails[index].SalaryHeadName;
        modalRef.componentInstance.Percentage = this.SalaryHeadDetails[index].SPercentage;
      }
    } else if (SelectType == 2) {
      modalRef.componentInstance.Formulas = structuredClone(this.Fromulas.filter((e: any) => (e.SelectType == 1 && this.common.ToLowerCase(e.EarningDeduction) == 'earning' && this.common.ToLowerCase(e.HeadType) == 'sb') || (e.SelectType == 2)));
      modalRef.componentInstance.Formula = this.AdditionalDetails[index].Column3;
      modalRef.componentInstance.SalaryHeadCode = this.AdditionalDetails[index].RCChargesCode;
      modalRef.componentInstance.SalaryHeadNamee = this.AdditionalDetails[index].RCChargesName;
      modalRef.componentInstance.Percentage = this.AdditionalDetails[index].Column2;
    } else if (SelectType == 3) {
      modalRef.componentInstance.Formulas = structuredClone(this.Fromulas.filter((e: any) => (e.SelectType == 1 && this.common.ToLowerCase(e.EarningDeduction) == 'earning' && this.common.ToLowerCase(e.HeadType) == 'sb') || (e.SelectType == 2) || (e.SelectType == 3)));
      modalRef.componentInstance.Formula = this.ServiceDetails[index].Column3;
      modalRef.componentInstance.SalaryHeadCode = this.ServiceDetails[index].ServiceChargeCode;
      modalRef.componentInstance.SalaryHeadNamee = this.ServiceDetails[index].ServiceChargeName;
      modalRef.componentInstance.Percentage = this.ServiceDetails[index].Column2;
    } else if (SelectType == 4) {
      modalRef.componentInstance.Formulas = modalRef.componentInstance.Formulas = structuredClone(this.Fromulas.filter((e: any) => e.SelectType == 1 && this.common.ToLowerCase(e.EarningDeduction) == 'earning' && this.common.ToLowerCase(e.HeadType) == 'sb'));
      if (Type == 'OTType') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetailsOTs.OTFormula;
      } else if (Type == 'SpecialOTType') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetailsOTs.SpecialOTFormula;
      } else if (Type == 'WOType') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetailsOTs.WOFormula;
      } else if (Type == 'LeaveType') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetailsOTs.LeaveFormula;
      } else if (Type == 'HolidayType') {
        modalRef.componentInstance.Formula = this.SalaryHeadDetailsOTs.HolidayFormula;
      }
    }

    modalRef.result.then(result => {
      if (result != null) {
        if (SelectType == 1) {
          if (Type == 'B') {
            this.SalaryHeadDetails[index].BFormula = result;
          }
          if (Type == 'B' || Type == 'S') {
            this.SalaryHeadDetails[index].SFormula = result;
          }
        } else if (SelectType == 2) {
          this.AdditionalDetails[index].Column3 = result;
        } else if (SelectType == 3) {
          this.ServiceDetails[index].Column3 = result;
        } else if (SelectType == 4) {
          if (Type == 'OTType') {
            this.SalaryHeadDetailsOTs.OTFormula = result;
          } else if (Type == 'SpecialOTType') {
            this.SalaryHeadDetailsOTs.SpecialOTFormula = result;
          } else if (Type == 'WOType') {
            this.SalaryHeadDetailsOTs.WOFormula = result;
          } else if (Type == 'LeaveType') {
            this.SalaryHeadDetailsOTs.LeaveFormula = result;
          } else if (Type == 'HolidayType') {
            this.SalaryHeadDetailsOTs.HolidayFormula = result;
          }
        }

        if (SelectType == 1) {
          this.CalculateOnAmount(this.SalaryHeadDetails[index], Type, SelectType);
        } else if (SelectType == 2) {
          this.CalculateOnAmount(this.AdditionalDetails[index], Type, SelectType);
        } else if (SelectType == 3) {
          this.CalculateOnAmount(this.ServiceDetails[index], Type, SelectType);
        }

        if (SelectType == 1 &&
          (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc' ||
            this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' ||
            this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie')) {
          if (Type == 'B') {
            if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].BFormula = result;
            } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].BFormula = result;
            } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].BFormula = result;
            }
          }
          if (Type == 'B' || Type == 'S') {
            if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')].SFormula = result;
            } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')].SFormula = result;
            } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
              this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')].SFormula = result;
            }
          }

          if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc') {
            this.CalculateOnAmount(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'lwf')], Type, SelectType);
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc') {
            this.CalculateOnAmount(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'pf')], Type, SelectType);
          } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie') {
            this.CalculateOnAmount(this.SalaryHeadDetails[this.SalaryHeadDetails.findIndex((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == 'esic')], Type, SelectType);
          }

        }
      }
    });
  }

  validatePercentage(element: any, control: any) {
    const value = parseFloat(element.BPercentage);
    if (!element.BPercentage) {
      element.invalid = false;
      return;
    }

    if (isNaN(value) || value > 100) {
      element.invalid = true;
    } else {
      element.invalid = false;
    }
  }

  CalculateOnAmount(element: any, Type: any, SelectType: number, OnChange = false) {
    let OnAmount = 0;
    if (SelectType == 1) {
      OnAmount = 0;
      if (Type == 'B') {
        element.SComputation = element.BComputation;
        element.SPercentage = element.BPercentage;
        element.SAmount = element.BAmount;
        element.SMonthlyYearly = element.BMonthlyYearly;
        element.SMaxAmount = element.BMaxAmount;
      }

      if ((this.common.ToLowerCase(element.BComputation) == 'formula' || this.common.ToLowerCase(element.BComputation) == 'fixed-parameter' || this.common.ToLowerCase(element.BComputation) == 'slab-rate') && Type == 'B') {
        element.BFormula.split("+").forEach((element: any) => {
          if (this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element)).length > 0) {
            OnAmount += Number(this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element))[0].BAmount);
          }
        });

        if (element.BMaxAmount == null || element.BMaxAmount == '' || Number(element.BMaxAmount) == 0) {
          element.BAmount = Number((OnAmount * Number(element.BPercentage)) / 100);
        } else if (Number(element.BMaxAmount) >= OnAmount) {
          element.BAmount = Number((OnAmount * Number(element.BPercentage)) / 100);
        } else if (element.BMaxAmount < OnAmount) {
          element.BAmount = Number((Number(element.BMaxAmount) * Number(element.BPercentage)) / 100);
        }

        element.SFormula = element.BFormula;
        element.SMaxAmount = element.BMaxAmount;
        element.SAmount = element.BAmount;
        element.SPercentage = element.BPercentage;
      } else if ((this.common.ToLowerCase(element.SComputation) == 'formula' || this.common.ToLowerCase(element.SComputation) == 'fixed-parameter' || this.common.ToLowerCase(element.SComputation) == 'slab-rate') && Type == 'S') {
        element.SFormula.split("+").forEach((element: any) => {
          if (this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element)).length > 0) {
            OnAmount += Number(this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element))[0].SAmount);
          }
        });

        if (element.SMaxAmount == null || element.SMaxAmount == '' || element.SMaxAmount == 0) {
          element.SAmount = Number((OnAmount * Number(element.SPercentage)) / 100);
        } else if (Number(element.SMaxAmount) >= OnAmount) {
          element.SAmount = Number((OnAmount * Number(element.SPercentage)) / 100);
        } else if (Number(element.SMaxAmount) < OnAmount) {
          element.SAmount = Number((Number(element.SMaxAmount) * Number(element.SPercentage)) / 100);
        }
      }

      if (Type == 'B') {
        this.SalaryHeadDetails.filter((e: any) => e.BFormula.includes(element.SalaryHeadCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, SelectType, OnChange);
        });
      } else if (Type == 'S') {
        this.SalaryHeadDetails.filter((e: any) => e.SFormula.includes(element.SalaryHeadCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, SelectType, OnChange);
        });
      }

      if (OnChange) {
        this.SalaryHeadDetails.forEach((element: any, index: number) => {
          if (Type == 'B' && this.common.ToLowerCase(element.BFormula).includes('gross')) {
            this.CalcGross(1, index, 'B');
          } else if (Type == 'S' && this.common.ToLowerCase(element.SFormula).includes('gross')) {
            this.CalcGross(1, index, 'S');
          }
        });
      }

      if (Type == 'B') {
        if (this.common.ToLowerCase(element.SalaryHeadCode) == 'esie' || this.common.ToLowerCase(element.SalaryHeadCode) == 'esic') {
          element.BAmount = this.ConvertCell(Number(element.BAmount));
        } else if (this.common.ToLowerCase(element.SalaryHeadCode) == 'pfc' || this.common.ToLowerCase(element.SalaryHeadCode) == 'pf') {
          element.BAmount = this.ConvertRound(Number(element.BAmount), 0);
        } else {
          element.BAmount = this.ConvertRound(Number(element.BAmount), 2);
        }
      }

      if (Type == 'B' || Type == 'S') {
        if (this.common.ToLowerCase(element.SalaryHeadCode) == 'esie' || this.common.ToLowerCase(element.SalaryHeadCode) == 'esic') {
          element.SAmount = this.ConvertCell(Number(element.SAmount));
        } else if (this.common.ToLowerCase(element.SalaryHeadCode) == 'pfc' || this.common.ToLowerCase(element.SalaryHeadCode) == 'pf') {
          element.SAmount = this.ConvertRound(Number(element.SAmount), 0);
        } else {
          element.SAmount = this.ConvertRound(Number(element.SAmount), 2);
        }
      }
    }
    if (SelectType == 1 || SelectType == 2) {
      OnAmount = 0;
      if (SelectType == 2) {
        if ((this.common.ToLowerCase(element.Computation) == 'formula' || this.common.ToLowerCase(element.Computation) == 'fixed-parameter' || this.common.ToLowerCase(element.Computation) == 'slab-rate')) {
          element.Column3.split("+").forEach((element: any) => {
            if (this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element)).length > 0) {
              OnAmount += Number(this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element))[0].BAmount);
            }
          });

          element.Column3.split("+").forEach((element: any) => {
            if (this.AdditionalDetails.filter((e: any) => this.common.ToLowerCase(e.RCChargesCode) == this.common.ToLowerCase(element)).length > 0) {
              OnAmount += Number(this.AdditionalDetails.filter((e: any) => this.common.ToLowerCase(e.RCChargesCode) == this.common.ToLowerCase(element))[0].A);
            }
          });

          element.A = Number((OnAmount * Number(element.Column2)) / 100);
          element.A = this.ConvertRound(Number(element.A), 2);
        }
        this.AdditionalDetails.filter((e: any) => e.Column3.includes(element.RCChargesCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, SelectType, OnChange);
        });

        this.ServiceDetails.filter((e: any) => e.Column3.includes(element.RCChargesCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, 3, OnChange);
        });
      } else if (SelectType == 1) {
        this.AdditionalDetails.filter((e: any) => e.Column3.includes(element.SalaryHeadCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, 2, OnChange);
        });
      }
    }
    if (SelectType == 1 || SelectType == 2 || SelectType == 3) {
      OnAmount = 0;
      if (SelectType == 3) {
        if ((this.common.ToLowerCase(element.Computation) == 'formula' || this.common.ToLowerCase(element.Computation) == 'fixed-parameter' || this.common.ToLowerCase(element.Computation) == 'slab-rate')) {
          element.Column3.split("+").forEach((element: any) => {
            if (this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element)).length > 0) {
              OnAmount += Number(this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.SalaryHeadCode) == this.common.ToLowerCase(element))[0].BAmount);
            }
          });

          element.Column3.split("+").forEach((element: any) => {
            if (this.AdditionalDetails.filter((e: any) => this.common.ToLowerCase(e.RCChargesCode) == this.common.ToLowerCase(element)).length > 0) {
              OnAmount += Number(this.AdditionalDetails.filter((e: any) => this.common.ToLowerCase(e.RCChargesCode) == this.common.ToLowerCase(element))[0].A);
            }
          });

          element.Column3.split("+").forEach((element: any) => {
            if (this.ServiceDetails.filter((e: any) => this.common.ToLowerCase(e.ServiceChargeCode) == this.common.ToLowerCase(element)).length > 0) {
              OnAmount += Number(this.ServiceDetails.filter((e: any) => this.common.ToLowerCase(e.ServiceChargeCode) == this.common.ToLowerCase(element))[0].A);
            }
          });

          element.A = Number((OnAmount * Number(element.Column2)) / 100);
          element.A = this.ConvertRound(Number(element.A), 2);
        }

        this.ServiceDetails.filter((e: any) => e.Column3.includes(element.ServiceChargeCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, SelectType, OnChange);
        });
      } else if (SelectType == 2) {
        this.ServiceDetails.filter((e: any) => e.Column3.includes(element.ServiceChargeCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, 3, OnChange);
        });
      } else if (SelectType == 1) {
        this.ServiceDetails.filter((e: any) => e.Column3.includes(element.SalaryHeadCode)).forEach((element: any) => {
          this.CalculateOnAmount(element, Type, 3, OnChange);
        });
      }

    }
    this.CalcTotal();

  }

  CheckIsDisabled(element: any, SelectType: number, Type = '') {
    if (SelectType == 1) {
      element.BPercentageIsDisabled = true;
      element.BAmountIsDisabled = true;
      element.BMaxAmountIsDisabled = true;
      element.SPercentageIsDisabled = true;
      element.SAmountIsDisabled = true;
      element.SMaxAmountIsDisabled = true;
    } else if (SelectType == 2) {
      element.OPercentageIsDisabled = true;
      element.OAmountIsDisabled = true;
    } else if (SelectType == 3) {
      element.SPercentageIsDisabled = true;
      element.SAmountIsDisabled = true;
    } else if (SelectType == 4) {
      if (Type == 'OTType') {
        element.OTRateIsDisabled = true;
        element.OTFormulaIsDisabled = true;
        element.OTCalculationOnIsDisabled = true;
        element.OTCalculationValueIsDisabled = true;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTRateIsDisabled = true;
        element.SpecialOTFormulaIsDisabled = true;
        element.SpecialOTCalculationOnIsDisabled = true;
        element.SpecialOTCalculationValueIsDisabled = true;
      } else if (Type == 'LeaveType') {
        element.LeaveValueIsDisabled = true;
        element.LeaveFormulaIsDisabled = true;
        element.LeaveCalculationOnIsDisabled = true;
        element.LeaveCalculationValueIsDisabled = true;
      } else if (Type == 'HolidayType') {
        element.HolidayValueIsDisabled = true;
        element.HolidayFormulaIsDisabled = true;
        element.HolidayCalculationOnIsDisabled = true;
        element.HolidayCalculationValueIsDisabled = true;
      } else if (Type == 'BOTType') {
        //element.OTBRateIsDisabled = true;
        element.BOTCalculationOnIsDisabled = true;
        element.BOTCalculationValueIsDisabled = true;
      } else if (Type == 'BHolidayType') {
        //element.NationalHolidayRateIsDisabled = true;
        element.BHolidayCalculationOnIsDisabled = true;
        element.BHolidayCalculationValueIsDisabled = true;
      }
    } else if (SelectType == 5) {
      if (Type == 'OTType') {
        element.OTCalculationValueIsDisabled = true;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTCalculationValueIsDisabled = true;
      } else if (Type == 'LeaveType') {
        element.LeaveCalculationValueIsDisabled = true;
      } else if (Type == 'HolidayType') {
        element.HolidayCalculationValueIsDisabled = true;
      } else if (Type == 'BOTType') {
        element.BOTCalculationValueIsDisabled = true;
      } else if (Type == 'BHolidayType') {
        element.BHolidayCalculationValueIsDisabled = true;
      }
    }

    if (SelectType == 1 && this.common.ToLowerCase(element.BComputation) == 'fixed value') {
      element.BAmountIsDisabled = false;
    } else if (SelectType == 2 && this.common.ToLowerCase(element.Computation) == 'fixed value') {
      element.OAmountIsDisabled = false;
    } else if (SelectType == 3 && this.common.ToLowerCase(element.Computation) == 'fixed value') {
      element.SAmountIsDisabled = false;
    } else if (SelectType == 4 && ((Type == 'OTType' && this.common.ToLowerCase(element.OTType) == 'fixed value')
      || (Type == 'SpecialOTType' && this.common.ToLowerCase(element.SpecialOTType) == 'fixed value')
      || (Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'fixed value')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'fixed value'))) {
      if (Type == 'OTType') {
        element.OTRateIsDisabled = false;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTRateIsDisabled = false;
      } else if (Type == 'LeaveType') {
        element.LeaveValueIsDisabled = false;
      } else if (Type == 'HolidayType') {
        element.HolidayValueIsDisabled = false;
      }
    } else if (SelectType == 5 && ((Type == 'OTType' && this.common.ToLowerCase(element.OTType) == 'formula' && this.common.ToLowerCase(element.OTCalculationOn) == 'fixed value')
      || (Type == 'SpecialOTType' && this.common.ToLowerCase(element.SpecialOTType) == 'formula' && this.common.ToLowerCase(element.SpecialOTCalculationOn) == 'fixed value')
      || (Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'formula' && this.common.ToLowerCase(element.LeaveCalculationOn) == 'fixed value')
      || (Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'percentage' && this.common.ToLowerCase(element.LeaveCalculationOn) == 'fixed value')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'formula' && this.common.ToLowerCase(element.HolidayCalculationOn) == 'fixed value')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'percentage' && this.common.ToLowerCase(element.HolidayCalculationOn) == 'fixed value')
      || (Type == 'BOTType' && this.common.ToLowerCase(element.BOTType) == 'onamount' && this.common.ToLowerCase(element.BOTCalculationOn) == 'fixed value')
      || (Type == 'BHolidayType' && this.common.ToLowerCase(element.BHolidayType) == 'onamount' && this.common.ToLowerCase(element.BHolidayCalculationOn) == 'fixed value'))) {
      if (Type == 'OTType') {
        element.OTCalculationValueIsDisabled = false;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTCalculationValueIsDisabled = false;
      } else if (Type == 'LeaveType') {
        element.LeaveCalculationValueIsDisabled = false;
      } else if (Type == 'HolidayType') {
        element.HolidayCalculationValueIsDisabled = false;
      } else if (Type == 'BOTType') {
        element.BOTCalculationValueIsDisabled = false;
      } else if (Type == 'BHolidayType') {
        element.BHolidayCalculationValueIsDisabled = false;
      }
    }
    // else if (this.common.ToLowerCase(element.BComputation) == 'fixed-parameter') {

    // }
    else if (SelectType == 1 && this.common.ToLowerCase(element.BComputation) == 'formula') {
      element.BMaxAmountIsDisabled = false;
      element.BPercentageIsDisabled = false;
    } else if (SelectType == 2 && this.common.ToLowerCase(element.Computation) == 'formula') {
      element.OPercentageIsDisabled = false;
    } else if (SelectType == 3 && this.common.ToLowerCase(element.Computation) == 'formula') {
      element.SPercentageIsDisabled = false;
    } else if (SelectType == 4 && ((Type == 'OTType' && this.common.ToLowerCase(element.OTType) == 'formula')
      || (Type == 'SpecialOTType' && this.common.ToLowerCase(element.SpecialOTType) == 'formula')
      || (Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'formula')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'formula'))) {
      if (Type == 'OTType') {
        element.OTFormulaIsDisabled = false;
        element.OTCalculationOnIsDisabled = false;
        element.OTCalculationValueIsDisabled = false;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTFormulaIsDisabled = false;
        element.SpecialOTCalculationOnIsDisabled = false;
        element.SpecialOTCalculationValueIsDisabled = false;
      } else if (Type == 'LeaveType') {
        element.LeaveFormulaIsDisabled = false;
        element.LeaveCalculationOnIsDisabled = false;
        element.LeaveCalculationValueIsDisabled = false;
      } else if (Type == 'HolidayType') {
        element.HolidayFormulaIsDisabled = false;
        element.HolidayCalculationOnIsDisabled = false;
        element.HolidayCalculationValueIsDisabled = false;
      }
    } else if (SelectType == 4 && ((Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'percentage')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'percentage'))) {
      if (Type == 'LeaveType') {
        element.LeaveFormulaIsDisabled = false;
        element.LeaveCalculationOnIsDisabled = false;
        element.LeaveCalculationValueIsDisabled = false;
      } else if (Type == 'HolidayType') {
        element.HolidayFormulaIsDisabled = false;
        element.HolidayCalculationOnIsDisabled = false;
        element.HolidayCalculationValueIsDisabled = false;
      }
    } else if (SelectType == 1 && this.common.ToLowerCase(element.BComputation) == 'pro-rated') {
      element.BAmountIsDisabled = false;
    } else if (SelectType == 2 && this.common.ToLowerCase(element.Computation) == 'pro-rated') {
      element.OAmountIsDisabled = false;
    } else if (SelectType == 3 && this.common.ToLowerCase(element.Computation) == 'pro-rated') {
      element.SAmountIsDisabled = false;
    } else if (SelectType == 4 && ((Type == 'OTType' && this.common.ToLowerCase(element.OTType) == 'onamount')
      || (Type == 'SpecialOTType' && this.common.ToLowerCase(element.SpecialOTType) == 'onamount')
      || (Type == 'BOTType' && this.common.ToLowerCase(element.BOTType) == 'onamount')
      || (Type == 'BHolidayType' && this.common.ToLowerCase(element.BHolidayType) == 'onamount'))) {
      if (Type == 'OTType') {
        element.OTRateIsDisabled = false;
        element.OTCalculationOnIsDisabled = false;
        element.OTCalculationValueIsDisabled = false;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTRateIsDisabled = false;
        element.SpecialOTCalculationOnIsDisabled = false;
        element.SpecialOTCalculationValueIsDisabled = false;
      } else if (Type == 'BOTType') {
        element.BOTCalculationOnIsDisabled = false;
        //element.BOTCalculationValueIsDisabled = false;
      } else if (Type == 'BHolidayType') {
        element.BHolidayCalculationOnIsDisabled = false;
        //element.BHolidayCalculationValueIsDisabled = false;
      }
    } else if (SelectType == 5 && ((Type == 'OTType' && this.common.ToLowerCase(element.OTType) == 'formula' && this.common.ToLowerCase(element.OTCalculationOn) == 'month days -')
      || (Type == 'SpecialOTType' && this.common.ToLowerCase(element.SpecialOTType) == 'formula' && this.common.ToLowerCase(element.SpecialOTCalculationOn) == 'month days -')
      || (Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'formula' && this.common.ToLowerCase(element.LeaveCalculationOn) == 'month days -')
      || (Type == 'LeaveType' && this.common.ToLowerCase(element.LeaveType) == 'percentage' && this.common.ToLowerCase(element.LeaveCalculationOn) == 'month days -')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'formula' && this.common.ToLowerCase(element.HolidayCalculationOn) == 'month days -')
      || (Type == 'HolidayType' && this.common.ToLowerCase(element.HolidayType) == 'percentage' && this.common.ToLowerCase(element.HolidayCalculationOn) == 'month days -')
      || (Type == 'BOTType' && this.common.ToLowerCase(element.BOTType) == 'onamount' && this.common.ToLowerCase(element.BOTCalculationOn) == 'month days -')
      || (Type == 'BHolidayType' && this.common.ToLowerCase(element.BHolidayType) == 'onamount' && this.common.ToLowerCase(element.BHolidayCalculationOn) == 'month days -'))) {
      if (Type == 'OTType') {
        element.OTCalculationValueIsDisabled = false;
      } else if (Type == 'SpecialOTType') {
        element.SpecialOTCalculationValueIsDisabled = false;
      } else if (Type == 'LeaveType') {
        element.LeaveCalculationValueIsDisabled = false;
      } else if (Type == 'HolidayType') {
        element.HolidayCalculationValueIsDisabled = false;
      } else if (Type == 'BOTType') {
        element.BOTCalculationValueIsDisabled = false;
      } else if (Type == 'BHolidayType') {
        element.BHolidayCalculationValueIsDisabled = false;
      }
    }

    if (SelectType == 1 && this.common.ToLowerCase(element.SComputation) == 'fixed value') {
      element.SAmountIsDisabled = false;
    } else if (SelectType == 1 && this.common.ToLowerCase(element.SComputation) == 'formula') {
      element.SMaxAmountIsDisabled = false;
      element.SPercentageIsDisabled = false;
    } else if (SelectType == 1 && this.common.ToLowerCase(element.SComputation) == 'pro-rated') {
      element.SAmountIsDisabled = false;
    }

    if (SelectType == 4) {
      this.CheckIsDisabled(element, 5, Type);
    }
  }

  DeleteHead(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then(result => {
      if (result) {
        if (this.SalaryHeadDetails.filter((e: any) => e.BFormula.includes(this.SalaryHeadDetails[index].SalaryHeadCode) || e.SFormula.includes(this.SalaryHeadDetails[index].SalaryHeadCode)).length > 0) {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = this.SalaryHeadDetails[index].SalaryHeadCode + " is currently used in the formula for " + this.SalaryHeadDetails.filter((e: any) => e.BFormula.includes(this.SalaryHeadDetails[index].SalaryHeadCode) || e.SFormula.includes(this.SalaryHeadDetails[index].SalaryHeadCode))[0].SalaryHeadCode + ". Please remove it from the formula.";
          modalRef.result.then((result: any) => { });
        } else {
          this.SalaryHeadDetails.splice(index, 1);
          this.CalcTotal();
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Delete Successfully";
          modalRef.result.then((result: any) => { });
        }
      }
    });
  }

  addHead() {
    const index = this.SalaryHeadDetails.findIndex((e: any) => e.SalaryHeadMasterID == this.Filter.SalaryHeadMasterID);
    if (index < 0) {
      this.SalaryHeadMasterSELECT(5)
    } else {
      this.toast.show({ message: 'Head already exist.', type: toastTypeEnum.warning });
    }
  }

  CalcGross(SelectType: number, index: number, Type: string) {
    if (SelectType == 1) {
      let CalAmount = 0;
      this.SalaryHeadDetails.filter((e: any) =>
        this.common.ToLowerCase(e.EarningDeduction) == 'earning' && this.common.ToLowerCase(e.Column1) == 'payslip'
        && ((Type == 'B' && this.common.ToLowerCase(e.BMonthlyYearly) == 'monthly')
          || (Type == 'S' && this.common.ToLowerCase(e.SMonthlyYearly) == 'monthly'))
        && (
          (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwfc' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'lwf')
          || (
            (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pf') && !this.ExcludefromPF.includes(this.common.ToLowerCase(e.SalaryHeadCode))
          ) || (
            (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esic') && !this.ExcludefromESI.includes(this.common.ToLowerCase(e.SalaryHeadCode))
          )
        )).map((e: any) => Type == 'B' ? e.BAmount : Type == 'S' ? e.SAmount : 0).forEach((element: any) => {
          if (element != null && element != "") {
            CalAmount += Number(element);
          }
        });

      if (Type == 'B') {
        if (this.SalaryHeadDetails[index].BMaxAmount == null || this.SalaryHeadDetails[index].BMaxAmount == '' || Number(this.SalaryHeadDetails[index].BMaxAmount) == 0) {
          this.SalaryHeadDetails[index].BAmount = Number((CalAmount * Number(this.SalaryHeadDetails[index].BPercentage)) / 100);
        } else if (Number(this.SalaryHeadDetails[index].BMaxAmount) >= CalAmount) {
          this.SalaryHeadDetails[index].BAmount = Number((CalAmount * Number(this.SalaryHeadDetails[index].BPercentage)) / 100);
        } else if (this.SalaryHeadDetails[index].BMaxAmount < CalAmount) {
          this.SalaryHeadDetails[index].BAmount = Number((Number(this.SalaryHeadDetails[index].BMaxAmount) * Number(this.SalaryHeadDetails[index].BPercentage)) / 100);
        }
      }
      if (Type == 'B' || Type == 'S') {
        if (this.SalaryHeadDetails[index].SMaxAmount == null || this.SalaryHeadDetails[index].SMaxAmount == '' || Number(this.SalaryHeadDetails[index].SMaxAmount) == 0) {
          this.SalaryHeadDetails[index].SAmount = Number((CalAmount * Number(this.SalaryHeadDetails[index].SPercentage)) / 100);
        } else if (Number(this.SalaryHeadDetails[index].SMaxAmount) >= CalAmount) {
          this.SalaryHeadDetails[index].SAmount = Number((CalAmount * Number(this.SalaryHeadDetails[index].SPercentage)) / 100);
        } else if (this.SalaryHeadDetails[index].SMaxAmount < CalAmount) {
          this.SalaryHeadDetails[index].SAmount = Number((Number(this.SalaryHeadDetails[index].SMaxAmount) * Number(this.SalaryHeadDetails[index].SPercentage)) / 100);
        }
      }
      if (Type == 'B') {
        if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esic') {
          this.SalaryHeadDetails[index].BAmount = this.ConvertCell(Number(this.SalaryHeadDetails[index].BAmount));
        } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pf') {
          this.SalaryHeadDetails[index].BAmount = this.ConvertRound(Number(this.SalaryHeadDetails[index].BAmount), 0);
        } else {
          this.SalaryHeadDetails[index].BAmount = this.ConvertRound(Number(this.SalaryHeadDetails[index].BAmount), 2);
        }
      }

      if (Type == 'B' || Type == 'S') {
        if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esie' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'esic') {
          this.SalaryHeadDetails[index].SAmount = this.ConvertCell(Number(this.SalaryHeadDetails[index].SAmount));
        } else if (this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pfc' || this.common.ToLowerCase(this.SalaryHeadDetails[index].SalaryHeadCode) == 'pf') {
          this.SalaryHeadDetails[index].SAmount = this.ConvertRound(Number(this.SalaryHeadDetails[index].SAmount), 0);
        } else {
          this.SalaryHeadDetails[index].SAmount = this.ConvertRound(Number(this.SalaryHeadDetails[index].SAmount), 2);
        }
      }

      this.CalcTotal();
    }
  }

  CalcTotal() {
    this.Totals.total = 0;
    this.Totals.billingtotal = 0;
    this.Totals.grosstotal = 0;
    this.Totals.deduction = 0;
    this.Totals.nettotal = 0;
    this.Totals.ctctotal = 0;
    this.Totals.benchmark = 0;

    this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.HeadType) == 'sb').map((e: any) => e.BAmount).forEach((element: any) => {
      if (element != null && element != "") {
        this.Totals.total += Number(element);
      }
    });

    this.AdditionalDetails.map((e: any) => e.A).forEach((element: any) => {
      if (element != null && element != "") {
        this.Totals.total += Number(element);
      }
    });

    this.ServiceDetails.map((e: any) => e.A).forEach((element: any) => {
      if (element != null && element != "") {
        this.Totals.total += Number(element);
      }
    });

    this.Totals.billingtotal = Number(this.Totals.total) + Number(this.Totals.roundoff);

    this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.EarningDeduction) == 'earning'
      && this.common.ToLowerCase(e.Column1) == 'payslip'
      && this.common.ToLowerCase(e.SMonthlyYearly) == 'monthly').map((e: any) => e.SAmount).forEach((element: any) => {
        if (element != null && element != "") {
          this.Totals.grosstotal += Number(element);
        }
      });

    this.SalaryHeadDetails.filter((e: any) => this.common.ToLowerCase(e.EarningDeduction) == 'deduction'
      && this.common.ToLowerCase(e.SalaryHeadCode) != 'lwfc'
      && this.common.ToLowerCase(e.SalaryHeadCode) != 'pfc'
      && this.common.ToLowerCase(e.SalaryHeadCode) != 'esie').map((e: any) => e.SAmount).forEach((element: any) => {
        if (element != null && element != "") {
          this.Totals.deduction += Number(element);
        }
      });

    this.Totals.nettotal = Number(this.Totals.grosstotal) - Number(this.Totals.deduction);
    this.Totals.ctctotal += this.Totals.grosstotal;

    this.SalaryHeadDetails.filter((e: any) => (this.common.ToLowerCase(e.EarningDeduction) == 'earning'
      && this.common.ToLowerCase(e.SMonthlyYearly) == 'yearly') || (this.common.ToLowerCase(e.SalaryHeadCode) == 'lwfc' ||
        this.common.ToLowerCase(e.SalaryHeadCode) == 'pfc' ||
        this.common.ToLowerCase(e.SalaryHeadCode) == 'esie')).map((e: any) => e.SAmount).forEach((element: any) => {
          if (element != null && element != "") {
            this.Totals.ctctotal += Number(element);
          }
        });

    if (this.Totals.billingtotal != null && this.Totals.billingtotal != "" && this.Totals.billingtotal > 0
      && this.Totals.ctctotal != null && this.Totals.ctctotal != "" && this.Totals.ctctotal > 0) {
      this.Totals.benchmark = ((this.Totals.billingtotal - this.Totals.ctctotal) / this.Totals.billingtotal) * 100;
    }

    this.Totals.total = this.Totals.total.toFixed(2);
    this.Totals.billingtotal = this.Totals.billingtotal.toFixed(2);
    this.Totals.grosstotal = this.Totals.grosstotal.toFixed(2);
    this.Totals.deduction = this.Totals.deduction.toFixed(2);
    this.Totals.nettotal = this.Totals.nettotal.toFixed(2);
    this.Totals.ctctotal = this.Totals.ctctotal.toFixed(2);
    this.Totals.benchmark = this.Totals.benchmark.toFixed(2);
  }

  MonthlyYearlyChange(index: number, Type: any) {
    if (Type == 'B') {
      this.SalaryHeadDetails[index].SMonthlyYearly = this.SalaryHeadDetails[index].BMonthlyYearly;
    }

    this.SalaryHeadDetails.forEach((element: any, index: number) => {
      if (Type == 'B' && this.common.ToLowerCase(element.BFormula).includes('gross')) {
        this.CalcGross(1, index, 'B');
      } else if (Type == 'S' && this.common.ToLowerCase(element.SFormula).includes('gross')) {
        this.CalcGross(1, index, 'S');
      }
    });
    this.CalcTotal();
  }

  ConvertCell(no: number) {
    return Math.ceil(no);
  }

  ConvertRound(no: number, Decimal: number) {
    if (Decimal == 0) {
      return Math.round(no);
    } else if (Decimal == 2) {
      return Math.round(no * 100) / 100;
    } else {
      return no;
    }
  }

  SelectDate(SelectType: string) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.MonthYear = this.dateFormat.parse(response.Table[0].RegistrationDate);

        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  upload(event: any) {
    if (this.common.PageRight.IsAdd) {
      try {
        if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
          const file = event.target.files[0];
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.UploadServices(this.common.CompanyParameterValue.ClientRateContractSalary, reader.result);
            event.target.value = null;
          };
        } else {
          this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
          event.target.value = null;
        }
      } catch (e) { }
    } else {
      event.target.value = null;
    }
  }

  UploadServices(Folder: string, Base64: any) {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        if (Folder == this.common.CompanyParameterValue.ClientRateContractSalary) {
          this.SalaryHeadDetailsOTs.DocumentPath = response.FileName;
          this.SalaryHeadDetailsOTs.DocumentPathWebESS = response.Url;
        }
      } else {
        this.toast.show({ message: 'File not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  clear() {
    this.IsReset = false;
    this.Fromulas = [];
    this.SalaryHeadDetails = [];
    this.AdditionalDetails = [];
    this.ServiceDetails = [];
    this.ExcludefromESI = [];
    this.ExcludefromPF = [];
    this.SalaryHeadDetailsOTs = {
      OTType: "",
      OTFormula: "",
      OTRate: 0,
      OTCalculationOn: "",
      OTCalculationValue: 0,
      SpecialOTType: "",
      SpecialOTFormula: "",
      SpecialOTRate: 0,
      SpecialOTCalculationOn: "",
      SpecialOTCalculationValue: 0,
      WOType: "",
      WOFormula: "",
      WOValue: 0,
      WOOption: "",
      TrackingNo: "",
      ID: 0,
      DocumentPath: "",
      SalaryTotal: 0,
      NetTotal: 0,
      CTCTotal: 0,
      WeeklyOffAmount: 0,
      LeaveType: "",
      LeaveFormula: "",
      LeaveValue: 0,
      HolidayType: "",
      HolidayFormula: "",
      HolidayValue: 0
    };
    this.SalaryHeadDetailsBillingOTs = {
      RoundOff: 0,
      TrackingNo: "",
      ID: 0,
      DocumentPath: "",
      OTBRate: 0,
      NationalHolidayRate: 0,
      BOTType: "",
      BOTCalculationOn: "",
      BOTCalculationValue: 0,
      BHolidayType: "",
      BHolidayCalculationOn: "",
      BHolidayCalculationValue: 0
    };
    this.Totals = {
      total: 0 as any,
      roundoff: 0 as any,
      billingtotal: 0 as any,
      deduction: 0 as any,
      grosstotal: 0 as any,
      nettotal: 0 as any,
      ctctotal: 0 as any,
      benchmark: 0 as any,
    }
  }
}
